import { useCallback } from "react";
import {
   UserVenuesClient,
} from "Services/API/API";
import {
   isAuthenticated,
   openConfirmVenueCreationPopup,
   openSignUpPopUp,
} from "../helpers";
import { useApiClient } from "Services/API/useApiClient";
import { IPlaceSelection } from "./usePlaceAddress";

interface UseCtaActionsProps {
   trackVPV?: () => void;
   placeSelection: IPlaceSelection | undefined;
   checkValidation: () => boolean;
}

interface UseCtaActionsReturn {
   spaceListHandler: () => void;
   waitListHandler: () => void;
}

export const useCtaActions = ({
   trackVPV,
   placeSelection,
   checkValidation,
}: UseCtaActionsProps): UseCtaActionsReturn => {
   const apiUserVenuesClient = useApiClient(UserVenuesClient);

   const openLoginPopup = useCallback(
      (onLogInSuccessCallback?: (props: unknown) => void, returnUrl?: string) => {
         trackVPV?.();
         openSignUpPopUp(onLogInSuccessCallback, returnUrl);
      },
      []
   );

   const spaceListHandler = useCallback(
      async (userId?: string) => {
         const isValid = checkValidation();
         if (isValid) {
            const placeId = placeSelection!.placePrediction.placeId;

            const url =
               "/ManageVenue/CreateVenue?" +
               new URLSearchParams({ googlePlaceId: placeId }).toString();

            if (isAuthenticated(userId)) {
               try {
                  const unfinishedVenues =
                     await apiUserVenuesClient.getUnfinished();
                  
                  if (unfinishedVenues?.length) {
                     //TODO: add user nick
                     openConfirmVenueCreationPopup(url.toString(), "");
                  } else {
                     open(url, "_self");
                  }
               } catch (e) {
                  console.error(e);
               }
            } else {
               openLoginPopup(spaceListHandler, url);
            }
         }
      },
      [
         openLoginPopup,
         apiUserVenuesClient,
         checkValidation,
         location,
         placeSelection,
      ]
   );

   const waitListHandler = useCallback(() => {
      const isValid = checkValidation();
      if (isValid) {
         LSHelper.Components?.WaitlistModal();
      }
   }, [checkValidation]);

   return { spaceListHandler, waitListHandler };
};
